const teeClipartTranslations = {
  fr: {
    FARBE: 'COULEUR',
    GRÖSSE: 'TAILLE',
    Größe: 'Taille',
    Grösse: 'Taille',
    'Wähle eine Option': 'Choisir une option',
    'Choose an option': 'Choisir une option',
    '1. Motiv:': '1. Motif :',
    '2. Motiv:': '2. Motif :',
    '3. Motiv:': '3. Motif :',
    'Motivanzahl*': 'Nombre de motifs*',
    Farbe: 'Couleur',
    'Farbe ändern': 'Changer la couleur',
    Weiss: 'Blanc',
    Weiß: 'Blanc',
    Schwarz: 'Noir',
    Blau: 'Bleu',
    Lila: 'Violet',
    Rosa: 'Rose',
    Türkis: 'Turquoise',
    Grün: 'Vert',
    Orange: 'Orange',
    Gelb: 'Jaune',
    Rot: 'Rouge',
    BLACK: 'Noir',
    'CA. 38 X 42 CM': 'env. 38 x 42 cm',
    Astrologie: 'Astrologie',
    'Alltag & Familie': 'Quotidien & famille',
    'Essen & Trinken': 'Nourriture & boissons',
    Fahrzeuge: 'Véhicules',
    'Feste & Feiertage': 'Fêtes & jours fériés',
    'Freizeit & Hobby': 'Loisirs & hobbies',
    Natur: 'Nature',
    Sport: 'Sport',
    Tiere: 'Animaux',
    'Städte, Welt & Kultur': 'Villes, monde & culture',
    'Zahlen & Buchstaben': 'Chiffres & lettres',
    Kindermotive: 'Motifs pour enfants',
    'Text hinzufügen?': 'Ajouter du texte ?',
    'Hier Text einfügen:': 'Ajouter le texte ici :',
    'Hier Text einfügen': 'Ajouter le texte ici',
    VORSCHAU: 'APERÇU',
    'ZUM WARENKORB HINZUFÜGEN': 'AJOUTER AU PANIER',
    'Kann ich ein Produkt zurückgeben?': 'Puis-je retourner un produit ?',
    'Emojis werden ggfs. in der Vorschau angezeigt aber können leider nicht gedruckt werden.':
      "Les emojis peuvent apparaître dans l'aperçu, mais ne peuvent malheureusement pas être imprimés.",
    'Emojis werden ggfs. in der Vorschau angezeigt aber köönen leider nicht gedruckt werden.':
      "Les emojis peuvent apparaître dans l'aperçu, mais ne peuvent malheureusement pas être imprimés.",
  },
  nl: {
    FARBE: 'KLEUR',
    GRÖSSE: 'MAAT',
    Größe: 'Maat',
    Grösse: 'Maat',
    'Wähle eine Option': 'Kies een optie',
    'Choose an option': 'Kies een optie',
    '1. Motiv:': '1. Motief:',
    '2. Motiv:': '2. Motief:',
    '3. Motiv:': '3. Motief:',
    'Motivanzahl*': 'Aantal motieven*',
    Farbe: 'Kleur',
    'Farbe ändern': 'Kleur wijzigen',
    Weiss: 'Wit',
    Weiß: 'Wit',
    Schwarz: 'Zwart',
    Blau: 'Blauw',
    Lila: 'Paars',
    Rosa: 'Roze',
    Türkis: 'Turkoois',
    Grün: 'Groen',
    Orange: 'Oranje',
    Gelb: 'Geel',
    Rot: 'Rood',
    BLACK: 'Zwart',
    'CA. 38 X 42 CM': 'ca. 38 x 42 cm',
    Astrologie: 'Astrologie',
    'Alltag & Familie': 'Dagelijks leven & familie',
    'Essen & Trinken': 'Eten & drinken',
    Fahrzeuge: 'Voertuigen',
    'Feste & Feiertage': 'Feesten & feestdagen',
    'Freizeit & Hobby': 'Vrije tijd & hobby',
    Natur: 'Natuur',
    Sport: 'Sport',
    Tiere: 'Dieren',
    'Städte, Welt & Kultur': 'Steden, wereld & cultuur',
    'Zahlen & Buchstaben': 'Cijfers & letters',
    Kindermotive: 'Kindermotieven',
    'Text hinzufügen?': 'Tekst toevoegen?',
    'Hier Text einfügen:': 'Voer hier tekst in:',
    'Hier Text einfügen': 'Voer hier tekst in',
    VORSCHAU: 'VOORBEELD',
    'ZUM WARENKORB HINZUFÜGEN': 'TOEVOEGEN AAN WINKELWAGEN',
    'Kann ich ein Produkt zurückgeben?': 'Kan ik een product retourneren?',
    'Emojis werden ggfs. in der Vorschau angezeigt aber können leider nicht gedruckt werden.':
      "Emoji's kunnen in het voorbeeld worden weergegeven, maar kunnen helaas niet worden gedrukt.",
    'Emojis werden ggfs. in der Vorschau angezeigt aber köönen leider nicht gedruckt werden.':
      "Emoji's kunnen in het voorbeeld worden weergegeven, maar kunnen helaas niet worden gedrukt.",
  },
  it: {
    FARBE: 'COLORE',
    GRÖSSE: 'TAGLIA',
    Größe: 'Taglia',
    Grösse: 'Taglia',
    'Wähle eine Option': "Scegli un'opzione",
    'Choose an option': "Scegli un'opzione",
    '1. Motiv:': '1° motivo:',
    '2. Motiv:': '2° motivo:',
    '3. Motiv:': '3° motivo:',
    'Motivanzahl*': 'Numero di motivi*',
    Farbe: 'Colore',
    'Farbe ändern': 'Cambia colore',
    Weiss: 'Bianco',
    Weiß: 'Bianco',
    Schwarz: 'Nero',
    Blau: 'Blu',
    Lila: 'Viola',
    Rosa: 'Rosa',
    Türkis: 'Turchese',
    Grün: 'Verde',
    Orange: 'Arancione',
    Gelb: 'Giallo',
    Rot: 'Rosso',
    BLACK: 'Nero',
    'CA. 38 X 42 CM': 'ca. 38 x 42 cm',
    Astrologie: 'Astrologia',
    'Alltag & Familie': 'Vita quotidiana & famiglia',
    'Essen & Trinken': 'Cibo & bevande',
    Fahrzeuge: 'Veicoli',
    'Feste & Feiertage': 'Feste & festività',
    'Freizeit & Hobby': 'Tempo libero & hobby',
    Natur: 'Natura',
    Sport: 'Sport',
    Tiere: 'Animali',
    'Städte, Welt & Kultur': 'Città, mondo & cultura',
    'Zahlen & Buchstaben': 'Numeri & lettere',
    Kindermotive: 'Motivi per bambini',
    'Text hinzufügen?': 'Aggiungere testo?',
    'Hier Text einfügen:': 'Inserisci qui il testo:',
    'Hier Text einfügen': 'Inserisci qui il testo',
    VORSCHAU: 'ANTEPRIMA',
    'ZUM WARENKORB HINZUFÜGEN': 'AGGIUNGI AL CARRELLO',
    'Kann ich ein Produkt zurückgeben?': 'Posso restituire un prodotto?',
    'Emojis werden ggfs. in der Vorschau angezeigt aber können leider nicht gedruckt werden.':
      "Le emoji possono apparire nell'anteprima, ma purtroppo non possono essere stampate.",
    'Emojis werden ggfs. in der Vorschau angezeigt aber köönen leider nicht gedruckt werden.':
      "Le emoji possono apparire nell'anteprima, ma purtroppo non possono essere stampate.",
  },
};

const getTeeLocale = () => {
  return String(window.Shopify?.locale || '')
    .toLowerCase()
    .split('-')[0];
};

const translateText = (text, dictionary) => {
  const cleanText = String(text || '')
    .replace(/\s+/g, ' ')
    .trim();

  return dictionary[cleanText] || text;
};

const translateClipartRows = () => {
  const locale = getTeeLocale();
  const dictionary = teeClipartTranslations[locale];

  if (!dictionary) return;

  document.querySelectorAll('#teeFormInputs .custom-clipart-row').forEach((row) => {
    row.querySelectorAll('.tee-field__heading > span').forEach((heading) => {
      const translatedText = translateText(heading.textContent, dictionary);

      if (heading.textContent !== translatedText) {
        heading.textContent = translatedText;
      }
    });

    row.querySelectorAll('select.tee-field__select option').forEach((option) => {
      const translatedText = translateText(option.textContent, dictionary);

      if (option.textContent !== translatedText) {
        option.textContent = translatedText;
      }
    });
  });
};

document.addEventListener('teeinblue-event-component-injected', () => {
  translateClipartRows();

  const teeFormInputs = document.querySelector('#teeFormInputs');

  if (!teeFormInputs || teeFormInputs.dataset.teeClipartTranslateObserved === 'true') return;

  teeFormInputs.dataset.teeClipartTranslateObserved = 'true';

  const observer = new MutationObserver(() => {
    translateClipartRows();
  });

  observer.observe(teeFormInputs, {
    childList: true,
    subtree: true,
  });
});


// Add preview design and edit design to qikify cart drawer
(() => {
  const WRAP_SEL = '.qsc2-product-item-wrapper';
  const VARIANT_SEL = '.qsc2-product-item__variant';
  const PREVIEW_CLASS = 'tee-preview-design';
  const EDIT_CLASS = 'tee-edit-customization';
  const CLOSE_QSC = '.qsc2-drawer-header__close-button';
  const CART_URL = '/cart.js';

  let pending = false;

  const debounce = (fn, wait = 150) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  function closeQscDrawer() {
    document.querySelector(CLOSE_QSC)?.click();
  }

  function ensureSingleActionDiv(wrapperEl, className, customizationId, anchorEl) {
    if (!wrapperEl || !customizationId || !anchorEl) return null;

    const idStr = String(customizationId);

    // Keep only 1 node per wrapper per class (cleanup old duplicates)
    const existing = Array.from(wrapperEl.querySelectorAll(`.${className}`));
    let el = existing[0] || null;
    if (existing.length > 1) {
      for (let i = 1; i < existing.length; i++) existing[i].remove();
    }

    if (!el) {
      el = document.createElement('div');
      el.className = className;
      anchorEl.insertAdjacentElement('afterend', el);
    } else {
      // Re-position to correct spot if needed
      if (anchorEl.nextElementSibling !== el) {
        anchorEl.insertAdjacentElement('afterend', el);
      }
    }

    // Ensure correct data attribute
    if (el.getAttribute('data-customization-id') !== idStr) {
      el.setAttribute('data-customization-id', idStr);
    }

    // Bind click only once
    if (!el.__teeBoundClose) {
      el.addEventListener('click', closeQscDrawer);
      el.__teeBoundClose = true;
    }

    return el;
  }

  // FIX: map wrappers top->bottom with cart.items top->bottom (no reverse)
  function mapWrappersToCartItems(wrappers, cartItems) {
    const items = cartItems || [];
    const mapped = [];
    const n = Math.min(wrappers.length, items.length);

    for (let i = 0; i < n; i++) {
      mapped.push([wrappers[i], items[i]]);
    }
    return mapped;
  }

  async function fetchCartJSON() {
    const res = await fetch(CART_URL, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async function syncPreviews() {
    if (pending) return;
    pending = true;

    try {
      const wrappers = Array.from(document.querySelectorAll(WRAP_SEL)).filter(Boolean);
      if (!wrappers.length) return;

      const cart = await fetchCartJSON();

      const pairs = mapWrappersToCartItems(wrappers, cart.items);
      for (const [wrapper, item] of pairs) {
        if (!item) continue;

        const props = item.properties || {};
        const customizationId = props._customization_id || props.customization_id || '';
        if (!customizationId) continue;

        const anchorVariant = wrapper.querySelector(VARIANT_SEL);
        if (!anchorVariant) continue;

        // Preview button
        const previewEl = ensureSingleActionDiv(wrapper, PREVIEW_CLASS, customizationId, anchorVariant);

        // Edit button right under Preview
        if (previewEl) {
          ensureSingleActionDiv(wrapper, EDIT_CLASS, customizationId, previewEl);
        }
      }
    } catch (e) {
      console.error('[tee-preview] sync error:', e);
    } finally {
      pending = false;
    }
  }

  const syncPreviewsDebounced = debounce(syncPreviews, 150);

  function observeWrappers() {
    const mo = new MutationObserver((mutations) => {
      let shouldSync = false;

      for (const m of mutations) {
        if (m.type !== 'childList' || !m.addedNodes?.length) continue;

        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.(WRAP_SEL) || node.querySelector?.(WRAP_SEL)) {
            shouldSync = true;
            break;
          }
        }
        if (shouldSync) break;
      }

      if (shouldSync) syncPreviewsDebounced();
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
    syncPreviewsDebounced();
  }

  window.addEventListener('cart:rendered', syncPreviewsDebounced);
  window.addEventListener('cart:updated', syncPreviewsDebounced);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWrappers);
  } else {
    observeWrappers();
  }
})();